import type z from 'zod';

import type { ReportSchema } from '@ballerine/common';

import { MerchantDetailsContent } from '@/components/templates/composites/MerchantDetailsContent/MerchantDetailsContent';

type DFMerchantDetailsContentProps = {
  merchantDetails: NonNullable<z.infer<typeof ReportSchema>['data']>['merchantDetails'];
  className?: string;
};

/**
 * DF's Operating Company Details, rendered by the shared composite (BAL-8249) so DF and PoS stay
 * aligned instead of drifting as two hand-maintained row lists.
 *
 * DF-specific flags: `resolveAddressFallbacks` preserves the `physicalAddresses` handling DF's own
 * implementation had; Entity Status stays off because DF does not populate `status`.
 */
export const DFMerchantDetailsContent: React.FC<DFMerchantDetailsContentProps> = ({
  merchantDetails,
  className,
}) => (
  <MerchantDetailsContent
    merchantDetails={merchantDetails}
    className={className}
    showAssociatedPersons
    resolveAddressFallbacks
  />
);
